<template>
    <div class="mb-4">
        {{ translate("Select Sub-Category") }}

        <select
            class="form-control"
            v-model="submission.sub_category_id"
            @change="resetSubSubCategoriesAndSave()"
        >
            <option value="" disabled>
                {{ translate("Select") }}
            </option>
            <option
                v-for="subCategory in sub_categories"
                :value="subCategory.id"
                :key="'sub-category-' + subCategory.id"
            >
                {{ subCategory.name }}
            </option>
        </select>
    </div>
</template>

<script>
import { useSubmissionWizardStore } from "@storesSw/SubmissionWizardStore";
import { mapWritableState, mapActions } from "pinia";

export default {
    props: ["sub_categories"],

    computed: {
        ...mapWritableState(useSubmissionWizardStore, ["submission"]),
    },

    methods: {
        ...mapActions(useSubmissionWizardStore, ["saveSubmission"]),

        resetSubSubCategoriesAndSave() {
            this.submission.sub_sub_category_id = "";

            this.saveSubmission();
        },
    },
};
</script>
